import '@swc/helpers/esm/_to_consumable_array.js';
import { noop } from './noop.js';

/**
 * Logs a warning when this function is called, in development environment only.
 */ var deprecate = function deprecate(fn, // @ts-ignore this parameter is used in the false branch
// eslint-disable-next-line no-unused-vars
message) {
    return fn;
};
/**
 * Logs a warning
 * This is used to log issues in development environment only.
 */ var warn = noop;
/**
 * Logs a warning if the condition is not met.
 * This is used to log issues in development environment only.
 */ var warning = noop;

export { deprecate, warn, warning };
